/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import {
  Breakpoint,
  MediaQueryService
} from 'app/services/media-query.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare const jQuery: any;

@Directive({ selector: '[enTooltip], [data-toggle="tooltip"]' })
export class TooltipDirective implements OnInit, OnDestroy, AfterViewInit {
  private el: HTMLElement;
  private observer: MutationObserver;

  @Input('template') template;

  componentDestroyed$: Subject<boolean> = new Subject();
  isDesktop = true;

  constructor(el: ElementRef, private _mediaQueryService: MediaQueryService) {
    this.el = el.nativeElement;
  }

  ngOnInit(): void {
    if (this.template && this.template.length > 0) {
      jQuery(this.el).tooltip({
        html: true,
        container: 'body',
        animation: false,
        template: this.template
      });
    }
    this._mediaQueryService
      .gt(Breakpoint.md)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(isDesktop => {
        this.isDesktop = isDesktop;
      });

    // Initialize BS4 tooltip
    jQuery(this.el).tooltip();

    // Watch for any 'title' attribute being added back
    this.observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'title') {
          const title = jQuery(this.el).attr('title');
          if (title) {
            jQuery(this.el)
              .attr('data-original-title', title)
              .removeAttr('title'); // immediately strip it
          }
        }
      });
    });

    this.observer.observe(this.el, {
      attributes: true,
      attributeFilter: ['title'] // only watch 'title' changes
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const element = this.el;
      if (!element.title && !element['data-original-title']) {
        element['data-original-title'] = element.innerText;
      }
    }, 200);
  }

  ngOnDestroy() {
    jQuery(this.el).hide();
    jQuery(this.el).tooltip('hide');

    this.observer?.disconnect();

    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  @HostListener('mouseenter') onMouseEnter() {
    jQuery(this.el).css('cursor', 'pointer');
    if (this.isDesktop) {
      this.showTooltip();
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    jQuery(this.el).tooltip('hide');
  }

  @HostListener('click') onClick() {
    this.showTooltip();
  }

  showTooltip() {
    const elt = jQuery(this.el);

    let position = 'top';
    if (elt.offset().left < 100) {
      if (elt.width() > jQuery(window).width() - 100) {
        position = 'top';
      } else {
        position = 'right';
      }
    } else if (elt.offset().left > jQuery(window).width() - 100) {
      position = 'left';
    } else if (elt.offset().top < 100) {
      position = 'bottom';
    }

    const tip = elt.data('bs.tooltip');
    if (tip) {
      tip.config.placement = elt.data('tooltip-placement') || position;
    }

    jQuery(this.el).tooltip('show');
  }
}
